import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="bg-forest-950 px-5 py-8 sm:py-14" data-id="element-242" data-mp="3r7pxrygtsh5k">
      <div className="mx-auto max-w-3xl text-center" data-id="element-243" data-mp="3racasdmhjov6">
        <p className="font-display text-base text-cream-50 sm:text-xl" style={{
        fontWeight: 700
      }} data-id="element-244" data-mp="3mghmewvxqlpr">
          🐾 Pack Sin Culpa, Sin Destrozos™
        </p>
        <p className="mx-auto mt-2.5 max-w-xl text-[0.78rem] leading-relaxed text-cream-200/75 sm:mt-4 sm:text-sm" data-id="element-245" data-mp="3dgutz0l6oq8u">
          El método N°1 para que tu perro esté en calma cuando te vas. Porque cuidar a tu peludo no debería
          costarte culpa ni un adiestrador caro.
        </p>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[0.78rem] sm:mt-7 sm:text-sm" data-id="element-246" data-mp="33krkf9o05pbv">
          <li data-id="element-247" data-mp="11r1zwe3r1j5x">
            <a href="mailto:armatedigitalsoporte@gmail.com" className="inline-flex items-center gap-1.5 text-cream-100 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-248" data-mp="11rk3xwwnl1oe">
              <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-249" data-mp="15q2bysvzvcbb" />
              armatedigitalsoporte@gmail.com
            </a>
          </li>
          <li data-id="element-250" data-mp="1anlqltwltr3s">
            <a href="https://instagram.com/armate_digital" className="inline-flex items-center gap-1.5 text-cream-100 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-251" data-mp="vsxmok6ur0qa">
              <InstagramIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-252" data-mp="1oh3a5epaj3tt" />
              @armate_digital
            </a>
          </li>
        </ul>

        <p className="mt-5 border-t border-cream-50/10 pt-4 text-[0.65rem] text-cream-200/50 sm:mt-9 sm:pt-6 sm:text-xs" data-id="element-253" data-mp="1tiiqwukfqo6e">
          © PackSinCulpaSinDestrozos™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}